module.exports = __webpack_public_path__ + "static/media/icon.c515f75b.png";